import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import { useForm, FormProvider } from "react-hook-form";


const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFEBEA",
    padding: "4em",
  },
};

const OtpEnterPopUp = ({ modalFlag= "", modalFlagUpdate, userOtp = "",modalPhoneVerifiedFlag }) => {

      const form = useForm({
        defaultValues: {},
      });
      const {
        register,
        control,
        handleSubmit,
        formState,
        watch,
        setValue,
        getValues,
        resetField,
        reset,
      } = form;
      const { errors } = formState;
  useEffect(() => {
    if (userOtp) {
      resetField("otpVerify");
    }
  }, [userOtp]);



  const onFormSubmit = async (data) => {
    if (data?.otpVerify == userOtp) {
        modalFlagUpdate(false);
        modalPhoneVerifiedFlag(true);
        toast.success("OTP verified successfully", {
          position: toast.POSITION.TOP_RIGHT,
          });
  
      } else {
  
          modalFlagUpdate(true);
          modalPhoneVerifiedFlag(false);
        toast.error("OTP verification failed", {
          position: toast.POSITION.TOP_RIGHT,
          });
      }

  }
  return (
    <div>
      <ReactModal
        isOpen={modalFlag}
        style={customStyles}
        contentLabel="Verify OTP"
        ariaHideApp={false} 
      >
        <h3 className="text-navyBlue"> OTP Verification  </h3>
        <FormProvider {...form}>
        <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
        <div className="mt-10 mb-20 ">
            
            <input
                      id="otpVerify"
                      {...register("otpVerify", {
                        required: {
                          value: true,
                          message: "OTP is Exactly 6 digits",
                        },
                        pattern: {
                          value: /^[0-9]/,
                          message: "Enter 6 Digits OTP",
                        },
                        minLength: { value: 6, message: "Enter 6 digits OTP" },
                        maxLength: { value: 6, message: "Enter 6 digits OTP" },
                      })}
                     
                      type="number"
                      className="form-control rounded-10 mb-15"
                      placeholder="Enter OTP"
    
                                      />
                                                      <p className="text-red">{errors.otpVerify?.message}</p>

    
    
    </div>
           
            
    
            <div className="mt-10 btn-wrapper">
            <button type="submit"
                className="btn-sm  btn-outline-green rounded-5"
              >
                Verify
              </button>
              <button
                className="btn-sm  btn-outline-red rounded-5"
                onClick={() => modalFlagUpdate(false)}
              >
                Close
              </button>
            
            </div>

        </form>
        </FormProvider>
      
      </ReactModal>
    </div>
  );
};

export default OtpEnterPopUp;
